import styles from "./UploadInputStyle.module.scss";

const UploadInputStyle = ({ children }) => (
  <div className={styles["wrapper"]}>{children}</div>
);

export default UploadInputStyle;
